import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getWebinarInfoRead(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getWebinarInfoRead',
        parameter: {
            userID: action.userID,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){

        if(action.onSuccess) {
            action.onSuccess(data.count);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getWebinarInfoRead",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getWebinarInfoReadSaga = takeEvery('GetWebinarInfoRead_Saga', getWebinarInfoRead);


function* setWebinarInfoRead(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setWebinarInfoRead',
        parameter: {
            userID: action.userID,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setWebinarInfoRead",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setWebinarInfoReadSaga = takeEvery('SetWebinarInfoRead_Saga', setWebinarInfoRead);

function* getContentList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getContentList',
        parameter: {
            id: action.id
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){

        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getContentList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getContentListSaga = takeEvery('GetContentList_Saga', getContentList);